import { z } from "zod";

import { trackSchema } from "../track";

import { longHeadSchema } from "./long-head";
import { emMachineSchema } from "./em-machine";

export const emServiceMachineSchema = emMachineSchema.merge(
	z.object({
		tracks: z.array(trackSchema),
		physicalMachineSettings: z.object({
			unit: z.string().optional(),
			longHead: z
				.object({
					longHeads: z.array(longHeadSchema),
				})
				.optional(),
		}),
		creaseTools: z.array(z.number()).optional(),
		cutTools: z.array(z.number()).optional(),
		activeLatches: z.array(z.number()).optional(),
		brakeTools: z.array(z.number()).optional(),
		rollerTools: z.array(z.number()).optional(),
		activeCrossHeadCrease: z.boolean().optional(),
		activeCrossHeadLatch: z.boolean().optional(),
		activeCrossHeadCut: z.boolean().optional(),
	}),
);

export type EmServiceMachine = z.infer<typeof emServiceMachineSchema>;
